import { compareDesc } from "date-fns";

export function compareValues<V = unknown>(valueA: V, valueB: V, type?: string): number {
  const a = valueA ?? null;
  const b = valueB ?? null;

  if (a === null && b !== null) {
    return -1;
  }

  if (b === null && a !== null) {
    return 1;
  }

  if (a === null && b === null) {
    return 0;
  }

  const valueType = type ?? typeof a;

  switch (valueType) {
    case "number":
    case "boolean":
      return Number(a) - Number(b);
    case "string":
      return String(a).localeCompare(String(b));
    case "date":
      if (a instanceof Date && b instanceof Date) {
        return compareDesc(a as Date, b as Date);
      }

      return 0;
    default:
      return 0;
  }
  return 0;
}
